// USE keywords SET, ADD, REMOVE, MODIFY, CHANGE, CLEAR, TOGGLE unless CREATE, READ, FETCH, UPDATE, DELETE
import getInitialState from '@/common/store/modules/rolesets/rolesets.state';

export const payloadFormatter = payload => (!payload || payload === 'none') ? '' : payload;

const mutations = {
  SET_ROLESETS(state, payload) {
    state.rolesets = payload.rolesets;
  },

  ADD_NETWORK(state, network) {
    state.rolesets = [...state.rolesets, network];
  },

  CHANGE_NETWORK(state, item) {
    const index = state.rolesets.findIndex(it => it.id === item.id);
    if (index === -1) {
      state.rolesets.push(item);
      return;
    }
    state.rolesets.splice(index, 1, item);
  },

  CHANGE_NETWORK_ROLE(state, networkRole) {
    state.networkRoles = state.networkRoles
      .map(_role => (_role.name === networkRole.oldName) || (_role.name === networkRole.name) ? networkRole : _role);
  },

  REMOVE_NETWORK(state, networkId) {
    state.rolesets = state.rolesets.filter(_network => _network.id !== networkId);
  },

  SET_NETWORK_ROLES(state, payload) {
    state.networkRoles = payload.networkRoles;
  },

  ADD_NETWORK_ROLE(state, networkRole) {
    state.networkRoles = [...state.networkRoles, networkRole];
  },

  REMOVE_NETWORK_ROLE(state, networkRoleName) {
    // const network = state.rolesets.find(_network => _network.id === networkRole.networkId)
    // network.networkRoles = network.networkRoles
    //   .filter(_networkRole => _networkRole.id !== networkRole.id)
    state.networkRoles = state.networkRoles.filter(_role => _role.name !== networkRoleName);
  },

  SET_NETWORKS_ERRORS(state, errors) {
    state.networkErrors = errors;
  },

  CLEAR_NETWORKS_ERRORS(state) {
    state.networkErrors = {};
  },

  SET_ENCRYPTION_TASK_STATE(state, status) {
    state.taskStatus = payloadFormatter(status);
  },

  FLUSH_STATE(state) {
    Object.assign(state, getInitialState());
  }
};

export default mutations;
